export const DeliverTO = ()=>{
    return(
        <>
            <div className="amazon-deliver-to text-white px-3">
                <div className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" height="20" width="20"><g><path d="M11.5,5c0,2.49-4.5,8.5-4.5,8.5S2.5,7.49,2.5,5a4.5,4.5,0,0,1,9,0Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="7" cy="5" r="1.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></circle></g></svg>
                    <div>
                        <span>Deliver to</span>
                        <h6>New Delhi 110033</h6>
                    </div>
                </div>
            </div>
        </>
    )
}
